import { memo } from 'react';

import { ENACO_LANDING_PAGE_LINK } from '@didaskill/ui/domain';

import EnacoLogo from '../../../../../assets/logo/LogoEnacoOrangeWithText.svg';
import { LoginPageSocialMedias } from '../social-medias/LoginSocialMedias';
import * as styles from './LoginHeader.styles';

export const LoginHeaderBase = () => {
  return (
    <div css={styles.header}>
      <a target="_blank" href={ENACO_LANDING_PAGE_LINK} rel="noreferrer">
        <svg width={147} height={32}>
          <EnacoLogo />
        </svg>
      </a>
      <div css={styles.socialMedias}>
        <LoginPageSocialMedias />
      </div>
    </div>
  );
};

export const LoginHeader = memo(LoginHeaderBase);
